module.exports = __webpack_public_path__ + "r-v3/img/text_off.1875d549.svg";